document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth >= 1024) {
    const interBubble = document.querySelector('.interactive');
    let curX = 0;
    let curY = 0;
    let tgX = 0;
    let tgY = 0;
    let isVisible = true;

    function checkVisibility() {
      const gradientBg = document.querySelector('.gradient-bg');
      if (gradientBg) {
        const rect = gradientBg.getBoundingClientRect();
        isVisible =
            rect.top < window.innerHeight &&
            rect.bottom > 0 &&
            rect.left < window.innerWidth &&
            rect.right > 0;
      } else {
        isVisible = false;
      }
    }

    function move() {
      if (isVisible) {
        curX += (tgX - curX) / 50;
        curY += (tgY - curY) / 50;
        interBubble.style.transform = `translate(${Math.round(
            curX
        )}px, ${Math.round(curY)}px)`;
      }
      requestAnimationFrame(() => {
        move();
      });
    }

    window.addEventListener('mousemove', (event) => {
      tgX = event.clientX;
      tgY = event.clientY;
    });

    window.addEventListener('scroll', checkVisibility);
    window.addEventListener('resize', checkVisibility);

    checkVisibility();
    move();
  }
});
